var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartebancaire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3218 0H2.39202C1.54422 0 0.856934 0.669812 0.856934 1.49607V21.8426C0.856934 22.6688 1.54422 23.3386 2.39202 23.3386H34.3218C35.1697 23.3386 35.8569 22.6688 35.8569 21.8426V1.49607C35.8569 0.669812 35.1697 0 34.3218 0Z",
    fill: "url(#paint0_linear_3399_9466)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9533 11.3148H18.7754C18.7324 10.299 18.4896 9.25166 17.753 8.57897C16.8756 7.77762 15.3387 7.48038 13.9655 7.48038C12.5362 7.48038 10.9555 7.8064 10.0735 8.66616C9.31288 9.40683 9.14844 10.5985 9.14844 11.6691C9.14844 12.7906 9.47013 14.0951 10.2953 14.8466C11.1727 15.6461 12.5944 15.8583 13.9655 15.8583C15.2974 15.8583 16.7402 15.6187 17.6125 14.8596C18.4824 14.1014 18.783 12.8244 18.783 11.6691V11.6637H13.9533V11.3148ZM19.0991 11.6639V15.671H25.8071V15.6656C26.7886 15.6135 27.5695 14.751 27.5695 13.692C27.5695 12.6325 26.7886 11.7147 25.8071 11.6621V11.6639H19.0991ZM25.7307 7.64818C26.6874 7.64818 27.4467 8.45713 27.4467 9.47792C27.4467 10.4443 26.7493 11.2335 25.8622 11.3149H19.0989V7.64231H25.519C25.5585 7.63758 25.6046 7.64093 25.6496 7.64417C25.6776 7.64614 25.7053 7.64818 25.7307 7.64818Z",
    fill: "#FEFEFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3399_9466",
    x1: 10.2099,
    y1: -3.33043,
    x2: 1.94956,
    y2: 22.6886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591647,
    stopColor: "#40CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3CB792"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartebancaire);
export default __webpack_public_path__ + "static/media/cartebancaire.42ca721059bcc7f0a51d102f210c4f25.svg";
export { ForwardRef as ReactComponent };